import { render, staticRenderFns } from "./CancellationReason.vue?vue&type=template&id=1047b07d&scoped=true&"
import script from "./CancellationReason.vue?vue&type=script&lang=js&"
export * from "./CancellationReason.vue?vue&type=script&lang=js&"
import style0 from "./CancellationReason.vue?vue&type=style&index=0&id=1047b07d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1047b07d",
  null
  
)

export default component.exports